import type { ViewStyle, ImageStyle } from 'react-native';

export const COMMON_STYLES = {
  button: {
    paddingVertical: 16,
    borderRadius: 12,
    alignItems: 'center',
    marginVertical: 8,
  } as ViewStyle,

  input: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderWidth: 2,
    borderRadius: 12,
    fontSize: 16,
  } as ViewStyle,

  socialButton: {
    width: 50,
    height: 50,
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  } as ViewStyle,

  logo: {
    width: 80,
    height: 80,
    resizeMode: 'contain',
  } as ImageStyle,

  splashLogo: {
    width: 140,
    height: 140,
    resizeMode: 'contain',
  } as ImageStyle,

  splashButton: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: 'center',
  } as ViewStyle,
};
